import React from 'react';
import { Box, Button, Stack } from '@common-ui/ui';
import { ArrowBack, Add, Download } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import MarkAsCompleteModal from '../../../components/modals/MarkAsCompleteModal';
import { useSelector } from 'react-redux';
import printPDFWithReportTitle from '../../../utils/printPDFWithReportTitle';
import routerPathEnum from '../../../enums/routerPathEnum';

export default function SecondaryNavigation() {
  const { reportInfo } = useSelector((state) => state.reportData);

  const history = useHistory();

  const handleReturn = () => {
    history.goBack();
  };

  const handleAddImages = () => {
    history.push({ pathname: routerPathEnum.IMAGES });
  };

  return (
    <Box gridColumn="span 12" sx={box} id="secondaryNavigation">
      <Box display="flex">
        <Button sx={{ color: 'black' }} onClick={handleReturn} startIcon={<ArrowBack />}>
          Return
        </Button>
      </Box>
      <Stack spacing={1} direction="row">
        {false && (
          <Button
            variant="contained"
            color="info"
            startIcon={<Add />}
            onClick={handleAddImages}
            disabled={reportInfo?.options?.finalized}
          >
            Add Images
          </Button>
        )}
        <MarkAsCompleteModal completed={reportInfo?.options?.finalized} />
        <Button
          variant="outlined"
          color="info"
          onClick={() => printPDFWithReportTitle(reportInfo)}
          startIcon={<Download />}
        >
          Download PDF
        </Button>
      </Stack>
    </Box>
  );
}

const box = {
  display: 'flex',
  justifyContent: 'space-between',
  p: 1,
  background: '#E8E8E8',
  color: 'rgba(0, 0, 0, 0.87)',
  borderBottom: '1px solid #8b8b8b',
  position: 'sticky',
  zIndex: 15,
  top: '0px',
};
